<template>
  <div v-if="!showDetail" style="height: 100%; display: flex; flex-direction: column;">
    <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search bpm-approval-process">
      <div class="section">
        <el-form
          label-position="left"
          label-width="85px"
        >
          <el-row style="margin-bottom: 5px;" :gutter="10">
            <el-col :span="24">
              <el-button type="primary" @click="toQuery">
                {{ $t('CargoMsg.Cargo_Query') }}
              </el-button>
              <el-button v-show="$checkPermission(['button_bpm_create'])" type="primary" @click="toCreateProcess">
                {{ $t('CargoMsg.Cargo_CreateProcess') }}
              </el-button>
              <el-button v-show="$checkPermission(['button_bpm_edit'])" type="primary" @click="toEditProcess">
                {{ $t('CargoMsg.Cargo_EditProcess') }}
              </el-button>
              <el-button v-show="$checkPermission(['button_bpm_copy'])" type="primary" @click="toCopyProcess">
                {{ $t('CargoMsg.Cargo_CopyProcess') }}
              </el-button>
              <el-button v-show="$checkPermission(['button_bpm_create'])" type="primary" @click="toAppoint">
                {{ $t('CargoMsg.Cargo_Appoint2') }}
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="$t('CargoMsg.Cargo_ProcessName')"
                prop="processName"
                class="auto-width"
              >
                <el-select
                  v-model="filter.name"
                  clearable
                  filterable
                  allow-create
                >
                  <el-option v-for="(item, index) in workflowGroupNameList" :key="index" :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_FormName')">
                <cargo-advance-select
                  tag-value="code"
                  :static-options="workflowTypes"
                  @parentCallBack="p=>{filter.documentConfigId=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch1')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office"
                  multiple
                  clearable
                  filterable
                  :default-multiple-value="filter.officeIdList"
                  @parentCallBack="p=>{filter.officeIdList = p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$t('CargoMsg.Cargo_WhetherItIsEnabled')"
                prop="initiateBranchCompany"
                class="auto-width"
              >
                <cargo-advance-select
                  :static-options="yesOrNotList"
                  clearable
                  tag-value="code"
                  @parentCallBack="p=>{filter.enabled=p.value}"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="grid-view approval-list-grid">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="261601"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @rowDataChanged="rowDataChanged"
          />
        </div>
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="261601"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!-- 委派 -->
    <appoint-dialog
      v-if="appointDialog.visible"
      :visible.sync="appointDialog.visible"
      :appoints="appoints"
      @change="doAppoint"
      @close="appointDialog.visible=false"
    />
  </div>
  <div v-else class="bpm-approval-process app-main-content" style="height: 100%">
    <div style="height: 28px; margin-left: 16px; margin-top: 16px">
      <el-button type="primary" @click="onSave()">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button type="default" @click="onCancel()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'271px','min-width':'271px'}"
      style="min-height: 90%;border: 1px solid;margin: 16px;"
    >
      <template slot="left">
        <div class="tabs-container section">
          <!-- Right tabs -->
          <el-tabs v-model="activeTab" type="card" style="width: 100%">
            <el-tab-pane :label="$t('SeaExport.activity')" name="activity">
              <el-form
                style="margin: 10px"
                label-position="top"
                label-width="200px"
              >
                <el-form-item :label="$t('CargoMsg.Cargo_ProcessName')" required>
                  <el-input v-model="form.name" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch1')" required>
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office"
                    multiple
                    clearable
                    filterable
                    :default-multiple-value="form.officeIds"
                    @parentCallBack="p=>{form.officeIds = p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_RevertProcess')" required>
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="revocationProcessStatus"
                    :default-value="form.canUndo"
                    @parentCallBack="p=>{form.canUndo=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_BindForm')" required>
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="formDropList"
                    :default-value="form.documentConfigId"
                    @parentCallBack="p=>{form.documentConfigId=p.value;documentConfigIdChange(p)}"
                  />
                </el-form-item>
                <el-form-item v-if="showInvoicingMode" :label="$t('CargoMsg.Cargo_InvoicingMode')" required>
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="formSubtypeList"
                    :default-value="form.formSubtype"
                    @parentCallBack="p=>{form.formSubtype=p.value}"
                  />
                </el-form-item>
                <el-form-item v-if="form.documentConfigId === WorkflowConstants.BILL_PAYMENT.code" :label="$t('CargoMsg.Cargo_AutoWriteOffAfterApproval')" required>
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="verificationList"
                    :default-value="form.autoWriteOffAfterApproval"
                    @parentCallBack="p=>{form.autoWriteOffAfterApproval=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_UnknownProcessProcessing')" required>
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="unknownProcessHandle"
                    :default-value="form.unknownProcessHandleMode"
                    @parentCallBack="p=>{form.unknownProcessHandleMode=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_QuickApprovalMode')" required>
                  <cargo-advance-select
                    tag-value="code"
                    :static-options="quickApprovalModes"
                    :default-value="form.quickApprovalMode"
                    @parentCallBack="p=>{form.quickApprovalMode=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_MessageNotificationMethod')" required>
                  <el-checkbox v-model="form.msgNotifyEmail">{{ $t('Viewer.email') }}</el-checkbox>
                  <el-checkbox v-model="form.msgNotifyBell">{{ $t('CargoMsg.Cargo_Bell') }}</el-checkbox>
                  <el-checkbox v-model="form.msgNotifyEnterpriseWechat">{{ $t('CargoMsg.Cargo_EnterpriseWechat') }}</el-checkbox>
                  <!--                  <el-checkbox v-model="form.msgNotifyWeixin">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>-->
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_Template_Push')">
                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
                    <cargo-advance-select
                      tag-name="name"
                      tag-value="uuid"
                      :static-options="templateList"
                      :default-value="form.templateUuid"
                      style="width: 49%"
                      filterable
                      :filter-tag-names="['name']"
                      filter-type="global"
                      @parentCallBack="p=>{form.templateUuid=p.value}"
                    />
                    <cargo-advance-select
                      tag-name="chineseName"
                      tag-value="code"
                      :static-options="exportTypeList"
                      :default-value="form.exportType"
                      style="width: 49%"
                      @parentCallBack="p=>{form.exportType=p.value}"
                    />
                  </div>
                </el-form-item>
                <el-form-item style="height: 120px;" :label="$t('SeaExport.Remarks')">
                  <el-input v-model="form.remark" type="textarea" />
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('Menu.Node')" name="node">
              <el-form
                :disabled="chooseIndex === null"
                style="margin: 10px;"
                label-position="top"
                label-width="200px"
                :class="chooseIndex === null ? 'no-click' : ''"
              >
                <el-form-item :label="$t('Sop.nodeName')" required>
                  <el-input v-model="node.nodeName" />
                </el-form-item>
                <el-form-item style="height: 120px;" :label="$t('CargoMsg.Cargo_ApproverSource')" required>
                  <el-radio-group v-model="node.actorType" style="display: grid;" @change="(val)=>node.actorType = val">
                    <div v-for="(item, index) in actorTypes" :key="index" style="display: flex">
                      <el-radio :label="item.code" @click.native="chooseActorType(item.code)">{{ isZh ? item.chineseName : item.englishName }}
                      </el-radio>
                      <i v-show="item.tips" :title="item.tips" class="el-icon-question tips" />
                    </div>
                  </el-radio-group>
                </el-form-item>

                <el-form-item style="height: 120px;" :label="$t('CargoMsg.Cargo_NotifierSource')">
                  <el-radio-group v-model="node.notifierType" style="display: grid;" @change="(val)=>node.notifierType = val">
                    <div v-for="(item, index) in notifierTypes" :key="index" style="display: flex">
                      <el-radio :label="item.code" @click.native="chooseNotifierType(item.code)">{{ isZh ? item.chineseName : item.englishName }}
                      </el-radio>
                      <i v-show="item.tips" :title="item.tips" class="el-icon-question tips" />
                    </div>
                  </el-radio-group>
                </el-form-item>
                <!--前置审批条件-->
                <el-form-item v-if="form.documentConfigId === WorkflowConstants.BILL_PAYMENT.code" :label="$t('CargoMsg.Cargo_PreconditionsForApproval')" required>
                  <el-row v-for="(condition, index) in node.preCriteriaList" :key="index" style="margin-top: 10px;">
                    <el-col :span="10">
                      <el-select
                        v-model="condition.criteria"
                        @change="p => {preCriteriaChangeHandle(p)}"
                      >
                        <el-option
                          v-for="(item,index) in preCriteriaOptions"
                          :key="index"
                          :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                          :value="item.code"
                          :disabled="item.disable"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="4">
                      <el-select v-model="condition.operator" disabled>
                        <el-option
                          label="="
                          value="="
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="6">
                      <el-input v-model="condition.checkValue" />
                    </el-col>
                    <el-col :span="2" style="margin-left:2px; margin-bottom:2px;text-align: right;">
                      <div
                        class="criteria-remove"
                        @click="removeCriteria(index)"
                      >
                        -
                      </div>
                    </el-col>
                    <!-- 关系在第二行 -->
                    <el-col :span="8">
                      <el-select v-model="condition.relation">
                        <el-option
                          label="AND"
                          :value="1"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8" style="margin-top: 2px;">
                      <div
                        class="criteria-add"
                        @click="addCriteria()"
                      >
                        +
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ApproverExecutionMode')" required>
                  <el-radio-group v-model="node.nodeType" style="display: grid;" @change="(val)=>node.nodeType = val">
                    <div v-for="(item, index) in nodeTypes" :key="index" style="display: flex">
                      <el-radio :label="item.code">{{ isZh ? item.chineseName : item.englishName }}
                      </el-radio>
                      <i v-show="item.tips" :title="item.tips" class="el-icon-question tips" />
                    </div>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_RejectMethod')">
                  <el-checkbox v-model="node.cancelAllowed">{{ $t('CargoMsg.Cargo_AllowDirectReturnToInitiator') }}</el-checkbox>
                </el-form-item>
                <!-- BI仪表盘-->
                <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceDashboard.biDashboard')">
                  <el-input v-model="node.dashboardName" :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.dashboardName')" />
                  <el-input v-model="node.dashboardId" :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.dashboardId')" />
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
      <template slot="right">
        <div style="width: 99%; height: 96%; overflow: auto; display: flex; flex-direction: column; background-color: white; margin: 12px 12px 12px 6px" class="col">
          <div style="width: 100%; height: 100%">
            <draggable v-model="form.workflows" disabled animation="300" style="width: 100%;" @sort="sort">
              <transition-group style="width: 100%; ">
                <div v-for="(item, workflowIndex) in form.workflows" :key="item.priority" class="item" :title="rulesLabelName(item, true)">
                  <div style="width: 100%; height: 100%">
                    <div style="height: 36px; background-color: rgba(244, 249, 255);display: flex">
                      <img src="/static/move.svg" style="align-self: center;margin-left:5px;width:11px;height:11px;">
                      <span style="align-self: center; margin-left: 5px">{{ $t('CargoMsg.Cargo_Priority') + (workflowIndex + 1) }}</span>
                      <span style="align-self: center; margin-left: 40px; color: rgba(65, 141, 220)" @click="onConfiguration(workflowIndex)">{{ $t('CargoMsg.Cargo_TriggerConditions') + ': ' + getTriggerConditionsLabel(item.workflowRuleMode) }}</span>
                      <span style="align-self: center; margin-left: 40px;" @click="onConfiguration(workflowIndex)">{{ rulesLabelName(item, false) }}</span>
                      <i style="align-self: center; color: red; margin-right: 10px" class="el-icon-delete" @click.capture="removeBranchProcess(workflowIndex)" />
                    </div>
                    <draggable v-model="item.nodes" style="display: flex; flex-wrap: wrap; padding-left: 28px; margin-bottom: 15px;" :options="{handle:'.drag-handle'}" @end="toEnd">
                      <div v-for="(card, index) in item.nodes" :key="index" style="display: flex; flex-wrap: wrap; align-self: center; margin-top: 15px;">
                        <div
                          :class="'record-card ' + (item.priority === choosePriority && index === chooseIndex ? 'is-active' : '') + (card.isAdd ? ' no-drag' : '')"
                          @click="chooseNode(card, item.priority, index)"
                        >
                          <div v-if="!card.isAdd">
                            <div style="margin: 10px; display: flex">
                              <div class="drag-handle" style="padding-right: 10px;">
                                <i class="el-icon-rank" style="margin-right: 10px;" />
                                <span class="node-name">{{ card.nodeName }}</span>
                              </div>
                              <i class="el-icon-delete" @click.capture="removeNode(workflowIndex, index)" />
                            </div>
                            <div :title="showApproval(card, true)" class="card-content">
                              {{ showApproval(card) }}
                            </div>
                            <div :title="showNotifier(card, true)" class="card-content" style="margin-top: 10px">
                              {{ showNotifier(card) === '' ? '' : $t('CargoMsg.Cargo_CcPerson') + '：' + showNotifier(card) }}
                            </div>
                          </div>
                          <div v-else>
                            <div style="height: 100%;margin-top: 10%;text-align: center; ">
                              <span style="cursor: pointer;font-size: 40px;color: rgba(159, 180, 225)" @click.stop="addNode(workflowIndex, item.priority)">+</span>
                            </div>
                          </div>
                        </div>
                        <div v-if="index < item.nodes.length - 1" style="position: relative;">
                          <div class="arrow-container">
                            <div class="arrow-line" />
                            <div class="arrow-head" />
                          </div>
                        </div>
                      </div>
                    </draggable>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div>
              <el-button :disabled="addBranchProcessDisable" type="text" style="background-color: rgba(244, 249, 255); margin-left: 10px;margin-top: 10px" @click="addBranchProcess">{{ $t('CargoMsg.Cargo_AddBranchProcess') }}</el-button>
            </div>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 人员配置 -->
    <choose-user-dialog
      v-if="chooseUserDialog.visible"
      :visible.sync="chooseUserDialog.visible"
      :value="node.actorId"
      @close="chooseUserDialog.visible=false"
      @change="p => {
        node.actorId = p
        chooseUserDialog.visible=false}"
    />
    <!-- 岗位配置 -->
    <choose-role-dialog
      v-if="chooseRoleDialog.visible"
      :visible.sync="chooseRoleDialog.visible"
      :row-data="chooseRoleDialog.officeDeptRowData"
      :value="node.actorId"
      @close="chooseRoleDialog.visible=false"
      @change="p => {node.actorId = p}"
    />
    <!-- 角色配置 -->
    <choose-cast-dialog
      v-if="castConfigurationDialog.visible"
      :visible.sync="castConfigurationDialog.visible"
      :values="node.actorId"
      @close="castConfigurationDialog.visible=false"
      @change="p => {
        node.actorId = p
        castConfigurationDialog.visible = false
      }"
    />
    <!-- 人员配置 -->
    <choose-notifier-user-dialog
      v-if="chooseNotifierUserDialog.visible"
      :title="$t('CargoMsg.Cargo_SelectCcTo')"
      :visible.sync="chooseNotifierUserDialog.visible"
      :value="node.notifierId"
      @close="chooseNotifierUserDialog.visible=false"
      @change="p => {
        node.notifierId = p
        chooseUserDialog.visible=false}"
    />
    <!-- 岗位配置 -->
    <choose-notifier-role-dialog
      v-if="chooseNotifierRoleDialog.visible"
      :visible.sync="chooseNotifierRoleDialog.visible"
      :row-data="chooseNotifierRoleDialog.officeDeptRowData"
      :value="node.notifierId"
      @close="chooseNotifierRoleDialog.visible=false"
      @change="p => {node.notifierId = p}"
    />
    <!-- 角色配置 -->
    <choose-notifier-cast-dialog
      v-if="chooseNotifierCastDialog.visible"
      :visible.sync="chooseNotifierCastDialog.visible"
      :values="node.notifierId"
      @close="chooseNotifierCastDialog.visible=false"
      @change="p => {
        node.notifierId = p
        chooseNotifierCastDialog.visible = false
      }"
    />
    <!-- 规则配置 -->
    <rule-configuration-dialog
      v-if="ruleConfigurationDialog.visible"
      :visible.sync="ruleConfigurationDialog.visible"
      :rules="rules"
      :workflow="form.workflows[chooseWorkflowIndexRule]"
      :value="node.actorId"
      :office-ids="form.officeIds"
      @close="ruleConfigurationDialog.visible=false"
      @change="p => {form.workflows[chooseWorkflowIndexRule] = p}"
    />
    <!-- 绑定模板 -->
    <bind-approval-template-dialog
      v-if="bindApprovalTemplateDialog.visible"
      :visible="bindApprovalTemplateDialog.visible"
      @close="bindApprovalTemplateDialog.visible=false"
      @choose="chooseTemplate"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as RadioStatusConstants from '@/class/cargo/model/parameters/RadioStatusConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import ChooseUserDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import ChooseNotifierUserDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import ChooseRoleDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseRoleDialog'
import ChooseNotifierRoleDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseRoleDialog'
import ChooseCastDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseCastDialog.vue'
import ChooseNotifierCastDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseCastDialog.vue'
import { getOfficeDeptTree } from '@/api/office'
import {
  appointList, appointSave,
  configActive,
  configCopy,
  configDetail,
  configList,
  configRule,
  configWorkflow,
  getBranchProcessCountMaxLimit,
  getFormList, workflowGroupNameList
} from '@/api/workflow'
import * as commonUtil from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import RuleConfigurationDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/ruleConfigurationDialog'
import { getLoading } from '@/utils/utilBaseElement'
import lodash from 'lodash'
import BindApprovalTemplateDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/bindApprovalTemplateDialog'
import $store from '@/store'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AppointDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/appointDialog'
import { getTemplateList } from '@/api/sysManage/baseConfig/template'
import * as WorkFlowNodePreCriteriaConstants from '@/class/cargo/model/parameters/WorkFlowNodePreCriteriaConstants'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import { POSITION_CUSTOM_7 } from '@/class/cargo/model/parameters/WorkflowConstants'

export default {
  name: 'BpmApprovalProcess',
  components: { draggable, BindApprovalTemplateDialog, RuleConfigurationDialog, ChooseRoleDialog, ChooseNotifierRoleDialog, ChooseUserDialog, ChooseNotifierUserDialog, CargoLeftRightResize, CargoAdvanceSelect, AppointDialog, ChooseCastDialog, ChooseNotifierCastDialog },
  data() {
    return {
      checked: true,
      loading: false,
      isZh: this.$store.getters.language === 'zh',
      // 不能使用process的index去确定选中的分支，因为索引会变化，处理起来复杂；所有使用process的固定值priority去确定选中的分支
      choosePriority: null,
      chooseIndex: null,
      chooseWorkflowIndexRule: null,
      form: {
        name: '',
        officeIds: [],
        canUndo: 9,
        documentConfigId: null,
        unknownProcessHandleMode: WorkflowConstants.UNKNOWN_PROCESS_HANDLE_NOT_PASS.code,
        autoWriteOffAfterApproval: WorkflowConstants.VERIFICATION_0.code,
        quickApprovalMode: WorkflowConstants.FIRST_NODE_NEED_RESOLVE.code,
        msgNotifyEmail: false,
        msgNotifyBell: true,
        msgNotifyWeixin: false,
        msgNotifyEnterpriseWechat: false,
        remark: '',
        workflows: [{
          priority: 1,
          workflowRuleMode: WorkflowConstants.RULE_CONDITIONS_ALL.code,
          rules: [],
          nodes: [{
            isAdd: true,
            nodeName: '',
            actorType: null,
            nodeType: 0,
            // 抄送人来源
            notifierType: null,
            notifierId: null
          }]
        }],
        formSubtype: null
      },
      chooseUserDialog: {
        visible: false
      },
      chooseNotifierUserDialog: {
        visible: false
      },
      ruleConfigurationDialog: {
        visible: false
      },
      bindApprovalTemplateDialog: {
        visible: false
      },
      castConfigurationDialog: {
        visible: false
      },
      rules: [],
      officeDeptMap: {},
      chooseRoleDialog: {
        visible: false,
        officeDeptRowData: []
      },
      chooseNotifierRoleDialog: {
        visible: false,
        officeDeptRowData: []
      },
      chooseNotifierCastDialog: {
        visible: false
      },
      node: {
        isAdd: false,
        nodeName: '',
        actorType: null,
        nodeType: 0,
        actorId: null,
        cancelAllowed: false,
        // 抄送人来源
        notifierType: null,
        notifierId: null,
        preCriteriaList: [],
        dashboardName: '', // 仪表盘名称
        dashboardId: '' // 仪表盘Id
      },
      beforeActorType: 0,
      beforeNotifyType: 0,
      preCriteriaOptions: [],
      oldSelect: null,
      activeTab: 'activity',
      showDetail: false,
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      yesOrNotList: RadioStatusConstants.YES_NO_TYPES,
      revocationProcessStatus: Array.from(WorkflowConstants.REVOCATION_PROCESS_STATUS),
      rejectProcessStatus: Array.from(WorkflowConstants.REJECT_PROCESS_STATUS),
      // 列表页的表单下拉使用
      workflowTypes: Array.from(WorkflowConstants.WORKFLOW_TYPES),
      actorTypes: Array.from(WorkflowConstants.ACTOR_TYPES),
      notifierTypes: Array.from(WorkflowConstants.NOTIFIER_TYPES),
      nodeTypes: Array.from(WorkflowConstants.NODE_TYPES),
      unknownProcessHandle: Array.from(WorkflowConstants.UNKNOWN_PROCESS_HANDLE),
      verificationList: Array.from(WorkflowConstants.VERIFICATION_LIST),
      quickApprovalModes: Array.from(WorkflowConstants.QUICK_APPROVAL_MODE),
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: event => {
          this.selectRow = event.data
        },
        onSortChanged: this.rowDataChanged
      },
      columnDefs: [
        // {
        //   headerName: '', width: 55, checkboxSelection: true,
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessName'), field: 'name', colId: 'name', flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FormName'),
          field: 'documentConfigId',
          valueFormatter: (params) => {
            return ColumnUtils.workflowTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'), field: 'officeIds', colId: 'officeIds', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'runningState', colId: 'runningState', flex: 1,
          cellRenderer: params => {
            const changeEnabled = this.documentManage.getPath('toChangeEnabled')
            const id = params.data.id
            const name = params.value === 9 ? this.$t('CargoMsg.Cargo_Deactivate') : this.$t('CargoMsg.Cargo_Enable')
            const state = -params.value
            if (params.value === 9) {
              return `<button><div onclick="${changeEnabled}(${id}, ${state})" style="display: inline-block;color:rgba(217, 3, 29);margin-right: 5px;cursor: pointer">${name}</div></button>`
            }
            return `<button><div onclick="${changeEnabled}(${id}, ${state})" style="display: inline-block;color:rgba(146, 199, 63);margin-right: 5px;cursor: pointer">${name}</div></button>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessComment'), field: 'remark', colId: 'remark', flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifierId',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'lastModified',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'creatorId',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'createTime',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      filter: {
        total: 0,
        pageNum: 0,
        pageSize: 20,
        // startDate: '',
        name: '',
        documentConfigId: null,
        enabled: null,
        officeIdList: []
        // approvalDate: '',
        // approveIdList: [],
        // state: 0,
        // approvalTemplate: '',
        // documentConfigIdList: [],
        // documentProcessNo: ''
      },
      rowData: [],
      selectRow: null,
      branchProcessCountMaxLimit: 0,
      addBranchProcessDisable: true,
      // 详情页的表单下拉使用
      formDropList: [],
      // 表单子类型
      formSubtypeList: [],
      // v3模板
      templateList: [],
      // 流程名称下拉
      workflowGroupNameList: [],
      // 刚打开这个流程编辑页面，若【绑定表单】下拉列表没有之前保存的值，则加入其中
      justOpenFlag: true,
      // v3导出文件类型
      exportTypeList: Array.from(WorkflowConstants.EXPORT_TYPE_LIST),
      appointDialog: {
        visible: false
      },
      appoints: [],
      WorkflowConstants: WorkflowConstants
    }
  },
  computed: {
    WorkFlowNodePreCriteriaConstants() {
      return WorkFlowNodePreCriteriaConstants
    },
    showInvoicingMode() {
      return this.form.documentConfigId === WorkflowConstants.MAKE_INVOICE.code || this.form.documentConfigId === WorkflowConstants.COLLECT_INVOICE.code
    }
  },
  watch: {
    email(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!newVal) {
          this.form.notifyUserId = []
        }
      }
    },
    'form.documentConfigId': {
      // immediate: true,
      async handler(newVal) {
        // 最大分支数限制处理
        if (this.form.documentConfigId && this.form.officeIds && this.form.officeIds.length > 0) {
          getBranchProcessCountMaxLimit({
            documentConfigId: this.form.documentConfigId,
            officeIds: this.form.officeIds.join(',')
          }).then(res => {
            this.branchProcessCountMaxLimit = res.data
            if (this.form.workflows.length < this.branchProcessCountMaxLimit) {
              this.addBranchProcessDisable = false
            } else {
              this.addBranchProcessDisable = true
            }
          })
        }
        // this.form.formSubtype = null
        this.formSubtypeList = []
        // this.form.templateUuid = null
        this.templateList = []
        if (newVal) {
          configRule({ documentConfigId: this.form.documentConfigId }).then(res => {
            this.rules = res.data
          })
          if (WorkflowConstants.MAKE_INVOICE.code === newVal) {
            this.formSubtypeList = Array.from(WorkflowConstants.MAKE_INVOICE_SUBTYPE_LIST)
          } else if (WorkflowConstants.COLLECT_INVOICE.code === newVal) {
            this.formSubtypeList = Array.from(WorkflowConstants.COLLECT_INVOICE_SUBTYPE_LIST)
          }

          if (!this.formSubtypeList.find(item => {
            return item.code === this.form.formSubtype
          })) {
            this.form.formSubtype = null
          }
          await this.initTemplate()
          if (!this.templateList.find(item => {
            return item.uuid === this.form.templateUuid
          })) {
            this.form.templateUuid = null
          }
        } else {
          this.form.formSubtype = null
          this.form.templateUuid = null
        }
      }
    },
    'form.formSubtype': {
      // immediate: true,
      async handler(newVal) {
        // v3模板
        await this.initTemplate()
        if (!this.templateList.find(item => {
          return item.uuid === this.form.templateUuid
        })) {
          this.form.templateUuid = null
        }
      }
    },
    'form.officeIds': {
      // immediate: true,
      async handler() {
        if (!this.form.officeIds || this.form.officeIds.length === 0) {
          this.form.documentConfigId = null
          this.formDropList = []
          return
        }
        // 表单下拉列表数据源处理
        const formListRes = await getFormList({ officeIds: this.form.officeIds.join(',') })
        const formIds = formListRes.data.map((form) => { return form.id })
        this.formDropList = this.workflowTypes.filter(workflowType => {
          if (this.justOpenFlag && workflowType.code === this.form.documentConfigId) {
            return true
          }
          return formIds.indexOf(workflowType.code) !== -1
        })
        if (!this.justOpenFlag && formIds.indexOf(this.form.documentConfigId) === -1) {
          this.form.documentConfigId = null
        }
        await this.initTemplate()
        if (!this.templateList.find(item => {
          return item.uuid === this.form.templateUuid
        })) {
          this.form.templateUuid = null
        }
        this.justOpenFlag = false
        // else if (this.form.documentConfigId) {
        //   // 最大分支数限制处理
        //   getBranchProcessCountMaxLimit({ documentConfigId: this.form.documentConfigId, officeIds: this.form.officeIds.join(',') }).then(res => {
        //     this.branchProcessCountMaxLimit = res.data
        //     if (this.form.workflows.length < this.branchProcessCountMaxLimit) {
        //       this.addBranchProcessDisable = false
        //     } else {
        //       this.addBranchProcessDisable = true
        //     }
        //   })
        // }
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toChangeEnabled', function(id, state) {
      context.toChangeEnabled(id, state)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  async created() {
    await this.init()
    this.toQuery()
  },
  methods: {
    async init() {
      getOfficeDeptTree().then(res => {
        this.chooseRoleDialog.officeDeptRowData = res.data
        this.chooseNotifierRoleDialog.officeDeptRowData = res.data
        // 转义权限map
        const officeDeptMap = {}
        if (res.data && res.data.length > 0) {
          for (const item of res.data) {
            officeDeptMap[item.entityId] = this.isZh ? item.chineseName : item.englishName
          }
        }
        this.officeDeptMap = officeDeptMap
      })
      if (this.form.documentConfigId) {
        configRule({ documentConfigId: this.form.documentConfigId }).then(res => {
          this.rules = res.data
        })
        // // v3模板
        // await this.initFormSubtype()
      }
      workflowGroupNameList().then(res => {
        this.workflowGroupNameList = res.data
      })
    },
    async initTemplate() {
      // v3模板
      if (this.form.officeIds && this.form.officeIds.length > 0) {
        const params = { engine: 2 }
        if (this.form.officeIds.length === 1) {
          params.officeId = this.form.officeIds[0] // (选中一个公司的场景时)查询【总公司模板】+当前分公司
        } else if (this.form.officeIds.length > 1) {
          params.officeId = 1 // (选中多个公司的场景时)只查询【总公司模板】
        }
        if (WorkflowConstants.BILL_PAYMENT.code === this.form.documentConfigId) {
          params.templateType = 'BILLPAYMENT'
        } else if (WorkflowConstants.MAKE_INVOICE.code === this.form.documentConfigId) {
          if (WorkflowConstants.MAKE_INVOICE_BILLING.code === this.form.formSubtype) {
            params.templateType = 'INTERNALBILLING'
          } else if (WorkflowConstants.MAKE_INVOICE_INTERNAL_INVOICE.code === this.form.formSubtype) {
            params.templateType = 'INVOICE'
          }
        } else if (WorkflowConstants.Job_CHARGE.code === this.form.documentConfigId) {
          params.templateType = 'BOOKING'
        } else if (WorkflowConstants.PARTNER_APPLICATION_FORM.code === this.form.documentConfigId) {
          params.templateType = 'PARTNER'
        }
        if (params.templateType) {
          await getTemplateList(params).then(res => {
            this.templateList = res.data
          })
        }
      } else {
        this.templateList = []
      }
    },
    toQuery() {
      const params = this.filter
      WorkflowUtil.changeDateFilter(params)
      if (typeof params.enabled === 'boolean') {
        params.runningState = params.enabled ? 9 : -9
      } else {
        delete params.runningState
      }
      if (params.name) {
        params.name = params.name.trim()
      }
      this.loading = getLoading()
      configList(params).then(res => {
        this.rowData = res.data.list
        ColumnUtils.addSerialNumber(this.rowData)
        params.total = res.data.total
      }).finally(() => {
        this.loading.close()
      })
    },
    toCreateProcess() {
      this.form = {
        name: '',
        officeIds: [],
        canUndo: 9,
        documentConfigId: 1,
        unknownProcessHandleMode: WorkflowConstants.UNKNOWN_PROCESS_HANDLE_NOT_PASS.code,
        quickApprovalMode: WorkflowConstants.FIRST_NODE_NEED_RESOLVE.code,
        msgNotifyEmail: false,
        msgNotifyBell: true,
        msgNotifyWeixin: false,
        remark: '',
        workflows: [{
          priority: 1,
          workflowRuleMode: WorkflowConstants.RULE_CONDITIONS_ALL.code,
          rules: [],
          nodes: [{
            isAdd: true,
            nodeName: '',
            actorType: null,
            nodeType: 0,
            // 抄送人来源
            notifierType: null,
            notifierId: null,
            dashboardName: '', // 仪表盘名称
            dashboardId: '' // 仪表盘Id
          }]
        }]
      }
      this.node = {
        isAdd: false,
        nodeName: '',
        actorType: null,
        // 审批人来源
        nodeType: 0,
        actorId: null,
        // 抄送人来源
        notifierType: null,
        notifierId: null,
        dashboardName: '', // 仪表盘名称
        dashboardId: '' // 仪表盘Id
      }
      this.activeTab = 'activity'
      this.showDetail = true
    },
    async toEditProcess() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      await this.showProcessDetail(this.selectRow)
    },
    toCopyProcess() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      this.loading = getLoading()
      configCopy({ workflowGroupId: this.selectRow.id }).then(res => {
        this.$message.success(this.$t('SeaExport.CopySuccess'))
        workflowGroupNameList().then(res => {
          this.workflowGroupNameList = res.data
        })
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    toAppoint() {
      this.loading = getLoading()
      appointList().then(res => {
        this.appoints = res.data
        this.appointDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
      // configCopy({ workflowGroupId: this.selectRow.id }).then(res => {
      //   this.$message.success(this.$t('SeaExport.CopySuccess'))
      //   workflowGroupNameList().then(res => {
      //     this.workflowGroupNameList = res.data
      //   })
      //   this.toQuery()
      // }).finally(() => {
      //   this.loading.close()
      // })
    },
    doAppoint(appoints) {
      let request
      if (appoints.length === 1 && !appoints[0].fromUserId && !appoints[0].toUserId) {
        request = []
      } else {
        request = deepClone(appoints)
        if (request && request.length > 0) {
          request.forEach(item => delete item.id)
        }
      }
      this.loading = getLoading()
      appointSave(request).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.appointDialog.visible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    // 启用禁用
    toChangeEnabled(id, state) {
      this.loading = getLoading()
      configActive({ workflowGroupId: id, runningState: state }).then(res => {
        // this.form.runningState = state
        const array = this.rowData.filter(item => item.id === id)
        array[0].runningState = state
        this.gridOptions.api.refreshCells({ force: true })
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存
    async onSave() {
      const data = deepClone(this.form)
      data.notifyUserId = data.notifyUserId ? data.notifyUserId.join(',') : ''
      // 去掉新增的节点
      for (const workflow of data.workflows) {
        if (workflow.nodes && workflow.nodes.length > 0) {
          workflow.nodes = workflow.nodes.filter(item => !item.isAdd)
        }
      }
      // 数据校验
      if (this.check(data)) {
        return
      }
      if (data.id && !lodash.isEqual(this.oldSelect, data)) {
        const flag = await this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureAboutTheModificationProcessTips'), this.$t('CargoMsg.Cargo_AreYouSureAboutTheModificationProcess'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning',
          closeOnClickModal: false
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      this.loading = getLoading()
      configWorkflow(data).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        workflowGroupNameList().then(res => {
          this.workflowGroupNameList = res.data
        })
        this.onCancel()
        this.toQuery()
      }).finally(() => {
        this.loading.close()
        this.justOpenFlag = true
      })
    },
    onCancel() {
      this.selectRow = null
      this.showDetail = false
      this.justOpenFlag = true
    },
    onConfiguration(workflowIndex) {
      this.chooseWorkflowIndexRule = workflowIndex
      this.ruleConfigurationDialog.visible = true
    },
    onBindApprovalTemplate() {
      this.bindApprovalTemplateDialog.visible = true
    },
    async onRowDoubleClicked(event) {
      const data = event.data
      await this.showProcessDetail(data)
    },
    async showProcessDetail(data) {
      this.activeTab = 'activity'
      this.choosePriority = null
      this.chooseIndex = null
      this.node = {
        isAdd: false,
        nodeName: '',
        actorType: null,
        nodeType: 0,
        actorId: null,
        dashboardName: '', // 仪表盘名称
        dashboardId: '' // 仪表盘Id
      }
      this.loading = getLoading()
      await this.initTemplate()
      configDetail({ workflowGroupId: data.id }).then(res => {
        const data = res.data
        this.oldSelect = deepClone(data)
        data.notifyUserId = data.notifyUserId ? commonUtil.splitToNumberArray(data.notifyUserId, ',') : []
        data.officeIds = data.officeIds ? commonUtil.splitToNumberArray(data.officeIds, ',') : []
        // 添加新增节点数据
        data.workflows.forEach(workflow => {
          if (!workflow.nodes) {
            workflow.nodes = []
          }
          workflow.nodes.push({
            isAdd: true,
            nodeName: '',
            actorType: 0,
            nodeType: 0,
            dashboardName: '', // 仪表盘名称
            dashboardId: '' // 仪表盘Id
          })
        })
        this.form = data
        this.showDetail = true
      }).finally(() => {
        this.loading.close()
      })
    },
    addNode(workflowIndex, priority) {
      const nodes = this.form.workflows[workflowIndex].nodes
      const length = nodes.length
      const newNode = { isAdd: false,
        nodeName: this.$t('CargoMsg.Cargo_NotNamed'),
        actorType: null,
        nodeType: 0,
        dashboardName: '', // 仪表盘名称
        dashboardId: '' // 仪表盘Id
      }
      nodes.splice(length - 1, 0, newNode)
      this.chooseNode(newNode, priority, length - 1)
    },
    removeNode(workflowIndex, index) {
      // 删除节点
      if (this.choosePriority === this.form.workflows[workflowIndex].priority &&
        this.chooseIndex === index) {
        this.choosePriority = null
        this.chooseIndex = null
        this.node = {
          isAdd: false,
          nodeName: '',
          actorType: null,
          nodeType: 0,
          actorId: null,
          dashboardName: '', // 仪表盘名称
          dashboardId: '' // 仪表盘Id
        }
      }
      this.form.workflows[workflowIndex].nodes.splice(index, 1)
    },
    chooseNode(node, priority, index) {
      if (node.isAdd) {
        return
      }
      this.choosePriority = priority
      this.chooseIndex = index
      // 选中节点
      this.node = node
      this.activeTab = 'node'
      // 处理前置审批条件
      this.preCriteriaChangeHandle()
    },
    // 选择审批人
    chooseActorType(actorType) {
      // 选择上级领导不处理
      if (actorType === 2) {
        // 清空人员数组
        this.node.actorId = null
      }
      // 选择用户弹窗
      if (actorType === 1) {
        this.chooseUserDialog.visible = true
      }
      // 选择岗位弹窗
      if (actorType === 0) {
        this.chooseRoleDialog.visible = true
      }
      // 选择角色弹窗
      if (actorType === 3) {
        if (this.beforeActorType !== 3) {
          this.node.actorId = []
        }
        this.castConfigurationDialog.visible = true
      }
      this.beforeActorType = actorType
    },
    // 选择抄送人
    chooseNotifierType(notifierType) {
      // 选择上级领导不处理
      if (notifierType === 2) {
        // 清空人员数组
        this.node.notifierId = null
      }
      // 选择用户弹窗
      if (notifierType === 1) {
        this.chooseNotifierUserDialog.visible = true
      }
      // 选择岗位弹窗
      if (notifierType === 0) {
        this.chooseNotifierRoleDialog.visible = true
      }

      // 选择角色弹窗
      if (notifierType === 3) {
        if (this.beforeNotifyType !== 3) {
          this.node.notifierId = []
        }
        this.chooseNotifierCastDialog.visible = true
      }
      this.beforeNotifyType = notifierType
    },
    showApproval(node, isTitle = false) {
      if (node.actorType === 2) {
        // 清空人员数组
        return this.$t('CargoMsg.Cargo_Superior')
      }
      if (!node.actorId || node.actorId.length === 0) {
        return ''
      }
      const len = node.actorId.length
      const userList = isTitle ? node.actorId : node.actorId.slice(0, len > 3 ? 3 : len)
      // 选择用户弹窗
      if (node.actorType === 1) {
        const result = ColumnUtils.resolveMultipleColumnLabel(this.selectTypeNames.basic_data_User, 'userId', userList, 'chineseName')
        if (isTitle) {
          return result
        }
        return len > 3 ? result + ',...' : result
      }
      // 选择岗位弹窗
      if (node.actorType === 0) {
        const names = []
        for (const actor of userList) {
          names.push(this.officeDeptMap[actor])
        }
        if (len > 3 && !isTitle) {
          names.push('...')
        }
        return names.join(',')
      }
      if (node.actorType === 3) {
        const casts = []
        for (const actor of userList) {
          casts.push(WorkflowUtil.getWorkFlowCastByCode(actor))
        }
        if (len > 3 && !isTitle) {
          casts.push('...')
        }
        return casts.join(',')
      }
    },
    showNotifier(node, isTitle = false) {
      if (node.notifierType === 2) {
        // 清空人员数组
        return this.$t('CargoMsg.Cargo_Superior')
      }
      if (!node.notifierId || node.notifierId.length === 0) {
        return ''
      }
      const len = node.notifierId.length
      const userList = isTitle ? node.notifierId : node.notifierId.slice(0, len > 2 ? 2 : len)
      // 选择用户弹窗
      if (node.notifierType === 1) {
        const result = ColumnUtils.resolveMultipleColumnLabel(this.selectTypeNames.basic_data_User, 'userId', userList, 'chineseName')
        if (isTitle) {
          return result
        }
        return len > 2 ? result + ',...' : result
      }
      // 选择岗位弹窗
      if (node.notifierType === 0) {
        const names = []
        for (const notifier of userList) {
          names.push(this.officeDeptMap[notifier])
        }
        if (len > 2 && !isTitle) {
          names.push('...')
        }
        return names.join(',')
      }
      // 选择角色弹窗
      if (node.notifierType === 3) {
        const casts = []
        for (const actor of userList) {
          casts.push(WorkflowUtil.getWorkFlowCastByCode(actor))
        }
        if (len > 3 && !isTitle) {
          casts.push('...')
        }
        return casts.join(',')
      }
    },
    check(data) {
      if (!data.name || !data.name.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_ProcessName'))
        return true
      }
      if (!data.officeIds || data.officeIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectOfficeIds'))
        return true
      }
      if (!data.canUndo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_RevertProcess'))
        return true
      }
      if (!data.documentConfigId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDocumentConfigId2'))
        return true
      }
      if (!data.unknownProcessHandleMode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_UnknownProcessProcessing'))
        return true
      }
      if (!data.quickApprovalMode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_QuickApprovalMode'))
        return true
      }
      if (!data.msgNotifyBell && !data.msgNotifyEmail && !data.msgNotifyWeixin && !data.msgNotifyEnterpriseWechat) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_MessageNotificationMethod'))
        return true
      }
      if (data.workflows.length > this.branchProcessCountMaxLimit) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AddBranchProcessCheck'))
        return true
      }
      if (data.templateUuid && !data.exportType) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_Template_Push') + this.$t('CargoMsg.Cargo_FileType'))
        return true
      }
      data.name = data.name.trim()
      // 校验分支
      if (!data.workflows || data.workflows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WorkflowsBranchCountNotNull'))
        return true
      }
      for (const workflow of data.workflows) {
        const nodes = workflow.nodes
        // 校验节点
        if (!nodes || nodes.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintain') + this.$t('Menu.Node'))
          return true
        }
        // 校验规则 请设置流程触发条件。
        if (!(WorkflowConstants.RULE_CONDITIONS_NONE.code === workflow.workflowRuleMode)) {
          if (!workflow.rules || workflow.rules.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SetUpTheProcessTriggerCondition'))
            return true
          }
          for (const workflowRule of workflow.rules) {
            const tempRules = this.rules.filter(rule => rule.column === workflowRule.column)
            if (!tempRules || tempRules.length === 0) {
              this.$message.warning(this.$t('CargoMsg.Cargo_RuleError'))
              return true
            }
          }
        }
        for (const node of nodes) {
          if (!node.nodeName || !node.nodeName.trim()) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('Sop.nodeName'))
            return true
          }
          if (node.actorType === null) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ApproverSource'))
            return true
          }
          // 非上级主管需要判断是否选择人员或岗位
          if (!node.actorId || node.actorId.length === 0) {
            if (node.actorType === 0) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintain') + this.$t('CargoMsg.Cargo_RuleRole'))
              return true
            }
            if (node.actorType === 1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintain') + this.$t('CargoMsg.Cargo_Approver'))
              return true
            }
            if (node.actorType === 3) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintain') + this.$t('CargoMsg.Cargo_Post'))
              return true
            }
          }
          // 过滤criteria为空的数据
          if (node.preCriteriaList && node.preCriteriaList.length > 0) {
            node.preCriteriaList = node.preCriteriaList.filter(item => item.criteria)
          }
          node.nodeName = node.nodeName.trim()
        }
      }
      return false
    },
    chooseTemplate(template) {
      this.form.documentConfigId = template
    },
    toEnd() {
      this.choosePriority = null
      this.chooseIndex = null
      // 去掉选中节点
      this.node = {
        isAdd: false,
        nodeName: '',
        actorType: null,
        nodeType: 0,
        actorId: null,
        dashboardName: '', // 仪表盘名称
        dashboardId: '' // 仪表盘Id
      }
    },
    sort({ to, form, item, clone, oldIndex, newIndex }) {
      // console.log('form: ' + JSON.stringify(form))
      // console.log('to: ' + JSON.stringify(to))
      // console.log('oldIndex: ' + oldIndex)
      // console.log('newIndex: ' + newIndex)
      // console.log('item: ' + JSON.stringify(item))
      // console.log('process: ' + JSON.stringify(this.form.workflows))
    },
    async addBranchProcess() {
      this.form.workflows = [...this.form.workflows,
        {
          priority: !this.form.workflows || this.form.workflows.length === 0 ? 1 : Math.max(...this.form.workflows.map(({ priority }) => priority)) + 1,
          workflowRuleMode: WorkflowConstants.RULE_CONDITIONS_ALL.code,
          rules: [],
          nodes: [{
            isAdd: true,
            nodeName: '',
            actorType: null,
            nodeType: 0,
            // 抄送人来源
            notifierType: null,
            notifierId: null
          }]
        }]
      // 最大分支数限制处理
      if (this.form.workflows.length < this.branchProcessCountMaxLimit) {
        this.addBranchProcessDisable = false
      } else {
        this.addBranchProcessDisable = true
      }
    },
    removeBranchProcess(workflowIndex) {
      // 删除分支流
      if (this.choosePriority === this.form.workflows[workflowIndex].priority) {
        this.choosePriority = null
        this.chooseIndex = null
        this.node = {
          isAdd: false,
          nodeName: '',
          actorType: null,
          nodeType: 0,
          actorId: null,
          dashboardName: '', // 仪表盘名称
          dashboardId: '' // 仪表盘Id
        }
      }
      this.form.workflows.splice(workflowIndex, 1)
      // 最大分支数限制处理
      if (this.form.workflows.length < this.branchProcessCountMaxLimit) {
        this.addBranchProcessDisable = false
      } else {
        this.addBranchProcessDisable = true
      }
    },
    documentConfigIdChange(p) {
      // 当表单设置为非付款申请时，自动核销默认不开启
      if (!this.form.documentConfigId !== WorkflowConstants.BILL_PAYMENT.code) {
        this.form.autoWriteOffAfterApproval = WorkflowConstants.VERIFICATION_0.code
      }
    },
    rulesLabelName(item, all) {
      if (!item.rules || !Array.isArray(item.rules)) {
        return ''
      }
      let ruleLabelName = ''
      for (const ru of item.rules) {
        if (ruleLabelName) {
          ruleLabelName += ';'
        }
        ruleLabelName += this.doRuleLabel({ data: ru, value: ru.value })
      }
      if (ruleLabelName.length > 80 && !all) {
        return ruleLabelName.substring(0, 80) + '......'
      }
      return ruleLabelName
    },
    doRuleLabel(params) {
      // 结算对象
      if (params.data.column === 'accountId') {
        return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0')
      }
      if (params.data.column === 'paymentType') {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', params.value, 'name')
      }
      // 部门
      if (params.data.column === 'department') {
        if (!params.value) {
          return ''
        }
        const ids = (params.value instanceof Array) ? params.value : params.value.split(',')
        const label = []
        for (const id of ids) {
          label.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(id), 'chineseName'))
        }
        return label.join(',')
      }
      // 合作伙伴角色
      if (params.data.column === 'companyRole') {
        if (!params.value) {
          return ''
        }
        const ids = (params.value instanceof Array) ? params.value : params.value.split(',')
        const label = []
        for (const id of ids) {
          label.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_SystemConstants$COMPANY_ROLE_LIST, 'code', id, 'chineseName'))
        }
        return label.join(',')
      }
      const list = this.rules
      if (!list || list.length === 0) {
        return params.value
      }
      const data = list.filter(item => item.column === params.data.column)
      if (!data || data.length === 0 || !data[0].value) {
        return params.value
      }
      const array = JSON.parse(data[0].value)
      if (array.type !== 'enum') {
        return params.value
      }
      const result = array.data.filter(item => item.value === params.value)
      if (!result || result.length === 0) {
        return params.value
      }
      return result[0].valueAlias
    },
    getTriggerConditionsLabel(workflowRuleMode) {
      const state = SystemConstants.getCommonState(workflowRuleMode, WorkflowConstants.RULE_CONDITIONS)
      if (!state) return ''
      return $store.getters.language === 'zh' ? state.chineseName : state.englishName
    },
    rowDataChanged(params) {
      ColumnUtils.sortChanged(params, this.columnDefs, this.rowData)
    },
    preCriteriaChangeHandle(option) {
      this.preCriteriaOptions = [...WorkFlowNodePreCriteriaConstants.PRE_CRITERIA]
      // 遍历 preCriteriaOptions，将所有选项的 disable 属性先置为 false
      this.preCriteriaOptions.forEach(optionItem => {
        optionItem.disable = false
      })
      // 遍历 node.preCriteriaList，将匹配的选项的 disable 属性置为 true
      this.node.preCriteriaList.forEach(preCriteriaItem => {
        const matchingOption = this.preCriteriaOptions.find(optionItem => optionItem.code === preCriteriaItem.criteria)
        if (matchingOption) {
          matchingOption.disable = true
        }
      })
    },
    removeCriteria(index) {
      const matchItem = this.preCriteriaOptions.find(item => this.node.preCriteriaList[index].criteria === item.code && item.disable)
      if (matchItem) {
        // 如果找到匹配的元素，则添加 disable 属性为 true
        matchItem.disable = false
      }
      this.node.preCriteriaList.splice(index, 1)
    },
    addCriteria() {
      const initCriteria = {
        id: null,
        ctiteria: '',
        operator: '=',
        checkValue: '',
        relation: 1
      }
      this.node.preCriteriaList.push(initCriteria)
    }
  }
}
</script>

<style lang="scss">
.bpm-approval-process{
  .tabs-container{
    height: 100%;
  }
  .el-tabs__item{
    width: 130px;
  }
  .el-tabs__content{
    width: 270px;
  }
  textarea{
    max-height: 80px;
    min-height: 80px !important;
  }
  .el-radio-group{
    display: grid;
    .el-radio{
      margin-top: 5px;
    }
    .tips{
      font-size: 18px;
      margin-top: 4px;
      pointer-events: auto;
    }
  }
  /* 设置箭头容器样式 */
  .arrow-container {
    width: 100px; /* 宽度减半 */
    height: 10px; /* 高度减半 */
    top: 50%;
    bottom: 50%;
    position: relative;
  }

  /* 设置箭头线条样式 */
  .arrow-line {
    width: 90px;
    height: 1px; /* 高度减半 */
    background-color: #909399;
    margin-top: auto;
    margin-bottom: auto;
    position: absolute;
    top:0;
    bottom:0;
  }

  /* 设置箭头尖端样式 */
  .arrow-head {
    width: 0;
    height: 0;
    border-top: 5px solid transparent; /* 上边框宽度减半 */
    border-bottom: 5px solid transparent; /* 下边框宽度减半 */
    border-left: 10px solid #909399; /* 左边框宽度减半 */
    position: absolute;
    right:-1px;
  }

  /* 设置上半部分小三角形样式 */
  .arrow-head::before {
    content:"";
    width :0 ;
    height :0 ;
    border-top:none;
    border-left:none;
    border-right:none;
    border-bottom-width :1px ;/* 下 边 框 宽 度 减 半*/
    position:absolute;/* 绝 对 定位*/
    left:-9.5 px ;/* 左 移9.5像素*/
    top:-1 px ;/* 上 移1像素*/
  }

  /* 设置下半部分小三角形样式 */
  .arrow-head::after {
    content:"";
    width :0 ;
    height :0 ;
    border-bottom:none;/* 去 掉下 边 框*/
    border-left:none;/* 去 掉左 边 框*/
    border-right:none;/* 去 掉右 边 框*/
    border-top-width :1px ;/* 上 边 框 宽 度 减 半*/
    position:absolute;/* 绝 对 定位*/
    left:-9.5 px ;/* 左 移9.5像素*/
    bottom :-1 px ;/* 下 移1像素*/
  }

  .record-card{
    width: 180px; height: 95px;
    border-color: rgba(240, 240, 240, 1);
    border-style: solid;
    border-width: 3px;
    border-radius: 5px;
  }
  .is-active{
    background-color: #1f75d5b0 !important;
  }
  .card-content{
    margin: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 3;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /*! autoprefixer: on */
    text-align: center;
  }
  .node-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-icon-delete{
    margin-left:auto;
    cursor: pointer;
  }
  .no-click{
    pointer-events: none;
  }

  .no-drag {
    user-select: none;
    cursor: default;
  }
  .drag-handle {
    user-select: none;
    cursor: move;
  }
  .col {
    width: 100%;
    flex: 1;
    padding: 10px;
    border: solid 1px #eee;
    border-radius: 5px;
    float: left;
  }
  .item {
    border: solid 1px #eee;
    background-color: white;
  }
  .item:hover {
    background-color: #fdfdfd;
    cursor: move;
  }
  .item + .item {
    border-top: none;
    margin-top: 6px;
  }

  .criteria-add {
    width:33px;
    color: #8DAE56;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid #8DAE56;
    border-radius: 10px;
    font-size: 35px
  }
  .criteria-remove {
    width:33px;
    color: #E47470;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid #E47470;
    border-radius: 10px;
    font-size: 35px
  }
}
</style>
